<template>
  <mdb-modal size="lg"  :show="show" @close="$emit('close')">
    <mdb-modal-header>
      <mdb-modal-title>수행평가</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body style="font-size:15px">
      <div class="title bolder">평가일 : <date-picker2 v-model="task.testDate"/></div>
      <div class="title bolder">실습예제</div>
      <mdb-input type="textarea" class="my-0" :rows="10" v-model="task.testQuestion"/>
      <div class="title bolder">평가기준</div>
      <mdb-input type="textarea" class="my-0" :rows="10" v-model="task.testGuide"/>
      <div class="text-center mt-4">
        <mdb-btn color="primary" class="p-2 px-4" @click.native="$emit('ok')">저장</mdb-btn>
        <mdb-btn color="secondary" class="p-2 px-4" @click.native="$emit('close')">취소</mdb-btn>
      </div>
    </mdb-modal-body>
  </mdb-modal>
</template>
<script>
import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import NcsTraining from '@/models/NcsTraining'
export default {
  name: 'PerformTestDlg',
  components: { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody },
  props: ['show', 'value'],
  data () {
    return {
      TAG: 'PerformTestDlg',
      task: this.value
    }
  },
  computed: {
  },
  methods: {
    async load () {
    },
    onOk () {
      this.$emit('input')
      this.$emit('close')
    }
  },
  watch: {
    'value' () {
      this.task = this.value
    }
  },
  created () { this.load() }
}
</script>
